module.exports = __webpack_public_path__ + "img/empty-kitchener.37fc3e1.svg";